import React from 'react'
import QuotesCardInc from '../../../../../shared-ui/QuotesCardInc';

const Quotes = (props) => {



  return (
    <>

      <QuotesCardInc
      data={props.quotes}
      policy={props.policy}
      />
    </>

  )
}

export default Quotes